/* file description */
import { ProColumns } from '@cui/pro-components';
import { Popconfirm } from 'antd';
import React from 'react';
import { SPTableBaseMode } from './consts';
import type { UseColumnsProp } from './type';
import { cloneDeep } from 'lodash'

export const useColumnsProp: UseColumnsProp = ({
  columns,
  autoRowEditConfig,
  rowKey,
  tableBaseMode,
  optionColumns,
  showTableIndex,
}) => {
  const cloneColumns = cloneDeep(columns) || []
  if (showTableIndex) {
    cloneColumns.unshift({
      title: '序号',
      dataIndex: 'index',
      valueType: 'index',
      width: 80,
    },)
  }
  if (!autoRowEditConfig) {
    return cloneColumns;
  }
  if (!columns) {
    return;
  }
  // const targetOptionColumn = columns.find((item) => item.key === 'option');
  if (optionColumns) {
    // 以用户自定义的为准
    return cloneColumns.concat(optionColumns);
    // return columns;
  }
  const { onDelete, onSave } = autoRowEditConfig;
  if (!onDelete && !onSave) {
    return cloneColumns;
  }
  // 只读模式
  if (tableBaseMode === SPTableBaseMode.VIEW) {
    return cloneColumns;
  }

  // 自动处理！
  const optionsColumn: ProColumns<Record<any, any>, 'text'> = {
    title: '操作',
    valueType: 'option',
    key: 'option',
    fixed: 'right',
    align: 'center',
  };
  optionsColumn.render = (text, record, _, action) => {
    const OptionColumnResult = [];
    if (onSave) {
      OptionColumnResult.push(
        <a
          key="editable"
          onClick={() => {
            action?.startEditable?.(typeof rowKey === 'string' ? record[rowKey] : record.id);
          }}
        >
          编辑
        </a>,
      );
    }
    if (onDelete) {
      OptionColumnResult.push(
        <Popconfirm
          key="delete"
          title="确认要删除这一项吗?"
          onConfirm={async () => {
            await onDelete(typeof rowKey === 'string' ? record[rowKey] : record.id, record);
            action?.reload();
          }}
          okText="确认"
          cancelText="取消"
        >
          <a href="#">删除</a>
        </Popconfirm>,
      );
    }
    return OptionColumnResult;
  };
  return cloneColumns.concat(optionsColumn);
};
